
export default function Hero() {
  const handleStartProject = () => {
    const bookingSection = document.getElementById('booking');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=luxurious%20modern%20interior%20design%20living%20room%20with%20floor%20to%20ceiling%20windows%20natural%20sunlight%20streaming%20through%20elegant%20furniture%20sophisticated%20neutral%20color%20palette%20minimalist%20aesthetic%20clean%20lines%20contemporary%20architecture%20soft%20ambient%20lighting%20high%20end%20residential%20space%20professional%20photography&width=1920&height=1080&seq=hero-main&orientation=landscape"
          alt="Interior Design Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 pt-32 pb-24 w-full">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-center space-x-3 mb-12">
            <div className="flex -space-x-2">
              <div className="w-10 h-10 rounded-full bg-teal-500 border-2 border-white flex items-center justify-center">
                <i className="ri-user-line text-white text-sm"></i>
              </div>
              <div className="w-10 h-10 rounded-full bg-orange-500 border-2 border-white flex items-center justify-center">
                <i className="ri-user-line text-white text-sm"></i>
              </div>
              <div className="w-10 h-10 rounded-full bg-purple-500 border-2 border-white flex items-center justify-center">
                <i className="ri-user-line text-white text-sm"></i>
              </div>
            </div>
            <p className="text-white text-sm font-medium">Trusted by 500+ clients worldwide</p>
          </div>

          <div className="text-center space-y-8 mb-12">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Transform Your Space<br />with Urbanspaces
            </h1>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
              <button
                onClick={handleStartProject}
                className="bg-white text-gray-900 px-8 py-4 rounded-full font-medium text-base hover:bg-gray-100 transition-all flex items-center space-x-2 cursor-pointer whitespace-nowrap"
              >
                <span>Start Your Project</span>
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>

          <div className="flex justify-center">
            <p className="text-white text-lg max-w-2xl text-center leading-relaxed font-medium drop-shadow-lg">
              Award-winning interior design studio specializing in residential and commercial spaces with integrated digital solutions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
